import { AxiosError } from 'axios';

import { selectExaminationQuestions, selectExampleQuestion, selectNextQuestion } from '../../_utils/questionHelpers';
import { Examination } from '../_models';
import { Answer } from '../_models/Answer';
import { Question } from '../_models/Question';
import { ExaminationAction, ExaminationActionType } from './actions';

export type ExaminationState = {
  currentQuestion?: Question;
  data: Examination;
  error?: AxiosError;
  exampleQuestion?: Question;
  isLoading?: boolean;
  questions: Question[];
  result: Record<string, Answer>;
};

const initialState: ExaminationState = {
  currentQuestion: null,
  data: null,
  questions: [],
  result: {
    125: null,
    126: null,
    127: null,
    146: null,
    157: null,
    159: null,
    217: null,
    219: null,
    248: null,
    249: null,
    262: null,
    264: null,
    266: null,
    2703: null,
    275: null,
    293: null,
    307: null,
    321: null,
    336: null,
    344: null,
    351: null,
    3581: null,
    367: null,
    369: null,
    378: null,
    383: null,
    384: null,
    386: null,
    389: null,
    390: null,
    413: null,
    414: null,
    441: null,
    443: null,
    464: null,
    465: null,
    466: null,
    467: null,
    491: null,
    517: null,
    534: null,
    536: null,
    538: null,
    553: null,
    597: null,
    621: null,
    623: null,
    634: null,
    639: null,
    748: null,
  },
};

export default function reducer(state = initialState, action: ExaminationAction): ExaminationState {
  switch (action.type) {
    case ExaminationActionType.SelectNextQuestion:
      return {
        ...state,
        currentQuestion: selectNextQuestion(state.currentQuestion?.question_id, state.questions),
      };
    case ExaminationActionType.ShowNextResultQuestion: {
      const currentIndex = state.questions.indexOf(state.currentQuestion);
      return {
        ...state,
        currentQuestion: state.questions[currentIndex + 1],
      };
    }
    case ExaminationActionType.ShowPreviousResultQuestion: {
      const currentIndex = state.questions.indexOf(state.currentQuestion);
      return {
        ...state,
        currentQuestion: state.questions[currentIndex - 1],
      };
    }
    case ExaminationActionType.SetAnswer:
      return {
        ...state,
        result: { ...state.result, [action.payload.questionId]: action.payload.answer },
      };
    case ExaminationActionType.StartExampleQuestion: {
      const { questions, exampleQuestion } = selectExaminationQuestions(state.data.categories, state.data.questions);
      return {
        ...state,
        currentQuestion: exampleQuestion,
        exampleQuestion,
        questions,
        result: questions.reduce((acc, question) => ({ ...acc, [question.question_id]: null }), {}),
      };
    }
    case ExaminationActionType.FetchExamination:
      return initialState;
    case ExaminationActionType.FetchExaminationSuccess: {
      return {
        ...state,
        data: action.payload.examination,
        exampleQuestion: selectExampleQuestion(action.payload.examination.questions),
        isLoading: false,
      };
    }
    case ExaminationActionType.FetchExaminationError: {
      return {
        ...state,
        error: action.payload.error,
        isLoading: false,
      };
    }
    case ExaminationActionType.ShowResultQuestion:
      return {
        ...state,
        currentQuestion: action.payload.question,
      };
    case ExaminationActionType.StopExamination:
      return {
        ...initialState,
        data: state.data,
      };
    default:
      return state;
  }
}
